// 自前の最小 i18n。辞書はモジュールスコープの ref に置き、どこからでも t() を呼べる。
import { ref, computed } from 'vue'
import { ja, type I18nKey } from './ja'
import { en } from './en'

export type Locale = 'ja' | 'en'
const STORAGE_KEY = 'bpe.locale.v1'

function load(): Locale {
  try {
    const v = localStorage.getItem(STORAGE_KEY)
    if (v === 'ja' || v === 'en') return v
  } catch {
    /* localStorage 不可でも動く */
  }
  return 'ja'
}

export const locale = ref<Locale>(load())
const dict = computed(() => (locale.value === 'ja' ? ja : en))

export function setLocale(l: Locale): void {
  locale.value = l
  try {
    localStorage.setItem(STORAGE_KEY, l)
  } catch {
    /* ignore */
  }
  document.documentElement.lang = l
}

export function t(key: I18nKey, params?: Record<string, string | number>): string {
  let s: string = dict.value[key] ?? ja[key] ?? key
  if (params) for (const [k, v] of Object.entries(params)) s = s.replaceAll(`{${k}}`, String(v))
  return s
}

export function useI18n() {
  return { t, locale, setLocale }
}

export type { I18nKey }
